import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon40: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#A84A76"
        d="M8.488 0a.505.505 0 0 1 .444.248l4.872 4.871a.497.497 0 0 1 .189.484L14 7.498a.5.5 0 0 1-1 .004l-.007-1.488L8.521 6a.5.5 0 0 1-.49-.408l-.008-.09L8.001 1H1v18h6.5a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5V.5A.5.5 0 0 1 .5 0h7.988ZM13.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.643 2.205-4.53 5.243a3.5 3.5 0 0 0 4.53-5.243ZM13.5 11a3.5 3.5 0 0 0-2.643 5.795l4.53-5.243A3.487 3.487 0 0 0 13.5 11ZM9.005 1.736l.016 3.266 3.26.01-3.276-3.276Z"
      />
    </Svg>
  )
}
